
      const { Redirect } = require('gatsby-i18n');
      module.exports = Redirect;
  